import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
} from './member-logs.action';
import { MemberLogs } from './member-logs.model';

export interface MemberLogsRecordsState {
    listData: any[];
    singleData: MemberLogs;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: MemberLogsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
};


export const memberLogRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData: listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(resetState, () => initialState)  // Reset action handler
);